import { useEffect, useState } from "react";
import { Content, SubContent, Main } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import CalendarBig from "../../../components/CalendarBig";
import api from "../../../services/api";
import useWrapper from "../../../hooks/useWrapper";
import useFormat from "../../../hooks/utils/useFormat";

export default function Agenda() {
  const { config } = useWrapper();
  const { stringToDate } = useFormat();
  const [reload, setreload] = useState();
  const [loading, setloading] = useState();
  const [events2, setevents2] = useState();

  useEffect(() => {
    (async () => {
      try {
        setloading(true);
        const { data: _events } = await api.get("trainee/calendar", config);
        let _only_events = _events.map(__event => {
          const _date = stringToDate(__event.date_start);
          return {
            start: _date,
            end: _date,
            all_day: !!__event.all_day,
            title: __event.title,
            status: __event.status,
            done: __event.done,
            id: __event.id,
          };
        });
        setevents2(_only_events);
        setloading(false);
      } catch (__err) {
        console.log("__err", __err);
      }
    })();
  }, [reload]);

  return (
    <Main className={style.mainUser}>
      <Content noBG="true">
        <Row>
          <Col md={12} lg={2}>
            <MenuTrainee />
          </Col>
          <Col>
            <SubContent>
              <CalendarBig
                reload={reload}
                setreload={setreload}
                events={events2 || []}
                onSelectEvent={() => {}}
                loading={loading}
              />
            </SubContent>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
